/**
 *
 * IssueReasons14140 constants
 *
 */

export const BROKEN = '4018554108000';
export const LOST = '4018554107000';
export const ON_RETURN = '4050867686000';
